<template>
    <div
        ref="personCardWrapper"
        class="participant-card-wrapper"
        :class="{'active': editMode}">
        <div class="participant-card">
            <!-- IMPORTANT keep alive allows vee validate to check nested validation observers-->
            <KeepAlive>
                <slot />
            </KeepAlive>
        </div>
    </div>
</template>

<script>
export default {
    name: "PersonCardWrapper",
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        editMode: {
            handler(isEditMode) {
                if (isEditMode) {
                    this.$nextTick(() => {
                        if (this.$refs.personCardWrapper) {
                            this.$refs.personCardWrapper.scrollIntoView({behavior: "smooth"});
                        }
                    })
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.participant-card-wrapper.active {
    grid-column: 1/ -1;
}

.participant-card {
    box-shadow: $box-shadow;
    background: $white;
    padding: map-get($spacers, 3);
    height: 100%;
}

</style>